import React from 'react';

import { EVENT_ACTION_LOCAL } from 'constants/eventAction';

import { TagBeta } from 'components/TagBeta';

import { LinkListProps, linkType } from './types';

import SidebarLink from './SidebarLink';

const PrimaryLinkList: React.FC<LinkListProps> = ({ links, onLinkClick }) => (
    <>
        {links.map((link) => (
            <SidebarLink
                key={link.to}
                onClick={() => onLinkClick(link.eventAction)}
                type={linkType.Primary}
                itemLabel={link.eventAction === EVENT_ACTION_LOCAL.PERSONAL_PLAN ? TagBeta : undefined}
                {...link}
            />
        ))}
    </>
);

export default PrimaryLinkList;
